export default null;
export const ONE_LINK_PREFIX =
	'https://encar.onelink.me/DhHD?pid=Encar_MW&c=MW_%EC%95%B1%EC%A0%84%ED%99%98%20%EC%9C%A0%EB%8F%84%20%EB%B0%B0%EB%84%88&is_retargeting=true&af_click_lookback=10d';
// 주어지는 원링크에서 &deep_link_value부터의 값만 붙여주면 링크 완성
